var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 27957"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 27951"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 9086",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Outline / Communication /Phone-out"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.868 17.5a3.723 3.723 0 0 1-1.524-.325l-.758-.338A18.67 18.67 0 0 1 .892 7.426L.337 6.2a3.762 3.762 0 0 1 1.218-4.589L3.329.331a1.749 1.749 0 0 1 2.386.32L7.51 2.876a1.75 1.75 0 0 1-.319 2.5l-.67.5A11.822 11.822 0 0 0 11.638 11l.5-.67a1.75 1.75 0 0 1 2.5-.32l2.226 1.79a1.75 1.75 0 0 1 .319 2.387l-1.274 1.764a3.763 3.763 0 0 1-3.041 1.549zm-8.515-16a.25.25 0 0 0-.146.047L2.434 2.828A2.255 2.255 0 0 0 1.7 5.583L2.255 6.8a17.179 17.179 0 0 0 8.922 8.663l.013.005.764.34a2.234 2.234 0 0 0 .915.2 2.257 2.257 0 0 0 1.824-.932l1.274-1.764a.25.25 0 0 0-.046-.341L13.7 11.173a.249.249 0 0 0-.357.046l-.866 1.168a.75.75 0 0 1-.913.237 13.368 13.368 0 0 1-6.67-6.67.754.754 0 0 1 .237-.912L6.3 4.176a.251.251 0 0 0 .045-.358L4.548 1.593a.25.25 0 0 0-.195-.093z",
    transform: "translate(2.997 3)",
    style: {
      fill: "#8c8d99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.72.22a.75.75 0 0 1 .22.53v3.828a.75.75 0 0 1-1.5 0V2.561L1.28 5.72A.75.75 0 0 1 .22 4.659L3.379 1.5H1.361a.75.75 0 0 1 0-1.5h3.828a.75.75 0 0 1 .531.22z",
    transform: "translate(13.163 3.756)",
    style: {
      fill: "#1bc47d"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportColored);
export default __webpack_public_path__ + "static/media/support-colored.bdeed6f358a953b2d3114d2e951ce132.svg";
export { ForwardRef as ReactComponent };